// Import model
import { DataviewCustomerReviewResponse } from '../models/DataviewCustomerReviewResponse';

// Import base class serializer

// Import dependency types (models and enums used in properties)
import { CustomerReview } from '../models/CustomerReview';
import { DataView } from '../models/DataView';
import { FilterCustomerReviewRequest } from '../models/FilterCustomerReviewRequest';

// Import dependency serializers (for complex types)
import { CustomerReviewSerializer } from './CustomerReviewSerializer';
import { DataViewSerializer } from './DataViewSerializer';
import { FilterCustomerReviewRequestSerializer } from './FilterCustomerReviewRequestSerializer';

// Import derived type serializers (for polymorphic deserialization)

/**
 * Serializer for DataviewCustomerReviewResponse - handles JSON serialization and deserialization with type validation
 */
export class DataviewCustomerReviewResponseSerializer {
  /**
   * Deserializes a JSON string into a DataviewCustomerReviewResponse instance
   */
  static deserialize(json: string): DataviewCustomerReviewResponse {
    const obj = JSON.parse(json);
    return this.fromObject(obj);
  }

  /**
   * Deserializes a plain object into a DataviewCustomerReviewResponse instance
   */
  static fromObject(obj: any): DataviewCustomerReviewResponse {
    if (!obj) {
      throw new Error('Cannot deserialize null or undefined to DataviewCustomerReviewResponse');
    }


    const instance: DataviewCustomerReviewResponse = {
      result: obj['Result'] ? (obj['Result'] as any[]).map((item: any) =>
        CustomerReviewSerializer.fromObject(item)
      ) : [] as any,
      request: obj['Request'] ? FilterCustomerReviewRequestSerializer.fromObject(obj['Request']) : undefined as any,
      dataView: obj['DataView'] ? DataViewSerializer.fromObject(obj['DataView']) : undefined as any,
    };

    return instance;
  }

  /**
   * Deserializes a JSON string into an array of DataviewCustomerReviewResponse instances
   */
  static deserializeArray(json: string): DataviewCustomerReviewResponse[] {
    const arr = JSON.parse(json);
    if (!Array.isArray(arr)) {
      throw new Error('Expected JSON array');
    }
    return arr.map(obj => this.fromObject(obj));
  }

  /**
   * Serializes a DataviewCustomerReviewResponse instance to a JSON string
   */
  static serialize(instance: DataviewCustomerReviewResponse): string {
    return JSON.stringify(this.toObject(instance));
  }

  /**
   * Converts a DataviewCustomerReviewResponse instance to a plain object
   */
  static toObject(instance: DataviewCustomerReviewResponse): any {
    return {
      'Result': instance.result?.map((item: any) =>
        CustomerReviewSerializer.toObject(item)
      ),
      'Request': instance.request ? FilterCustomerReviewRequestSerializer.toObject(instance.request) : undefined,
      'DataView': instance.dataView ? DataViewSerializer.toObject(instance.dataView) : undefined,
    };
  }

  /**
   * Serializes an array of DataviewCustomerReviewResponse instances to a JSON string
   */
  static serializeArray(instances: DataviewCustomerReviewResponse[]): string {
    return JSON.stringify(instances.map(inst => this.toObject(inst)));
  }
}
